var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"name":"copyright"}},[_c('div',{staticClass:"copyright"},[_vm._v(" "+_vm._s(_vm.$t('footCot'))+" ")]),_c('div',{staticClass:"internationalization"},[_c('Lang')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }